import React, {useContext, useEffect, useState} from 'react';
import {Context} from '../../index';
import Container from '../../components/ui/Container';
import SectionHeading from '../../components/ui/SectionHeading';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Seo from '../../components/ui/Seo';
import ExamplesByCategoryModal from '../../components/ExamplesByCategoryModal/ExamplesByCategoryModal';
import {FEATURED_PRODUCTS, SERVICE_GROUPS} from '../../data/siteData';
import styles from './CalculatorsList.module.css';

const CalculatorsList = () => {
    const {global, posts} = useContext(Context);
    const [selectedCategory, setSelectedCategory] = useState('');
    global.setIsAdminPage(false);
    const openCategory = (category) => setSelectedCategory(category);
    const openCategoryFromKeyboard = (event, category) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openCategory(category);
        }
    };

    useEffect(() => {
        posts.loadAvailableCategories();
    }, [posts]);

    return (
        <>
        <Container className={styles.page}>
            <Seo
                title="Услуги и расчёт стоимости — 4 Цвета"
                description="Основные направления полиграфии 4 Цвета: печатная продукция, сувениры, макеты и дизайн."
            />
            <Breadcrumbs items={[{label: 'Услуги'}]}/>
            <section className={styles.hero}>
                <div>
                    <p className={styles.kicker}>Каталог услуг</p>
                    <h1>Полиграфия, сувенирная продукция и дизайн</h1>
                    <p>Выберите направление и свяжитесь с нами: мы уточним формат, тираж, материалы и подготовим расчёт.</p>
                    <div className={styles.actions}>
                    </div>
                </div>
            </section>

            <section className={styles.section}>
                <SectionHeading
                    eyebrow="Направления"
                    title="Что можно заказать"
                    text=""
                />
                <div className={styles.groups}>
                    {SERVICE_GROUPS.map((group) => {
                        const isAvailable = posts.isCategoryAvailable(group.exampleCategory);
                        return (
                        <article
                            key={group.title}
                            role={isAvailable ? 'button' : undefined}
                            tabIndex={isAvailable ? 0 : undefined}
                            className={`${styles.groupCard} ${isAvailable ? styles.clickable : ''}`}
                            onClick={isAvailable ? () => openCategory(group.exampleCategory) : undefined}
                            onKeyDown={isAvailable ? (event) => openCategoryFromKeyboard(event, group.exampleCategory) : undefined}
                        >
                            <img src={group.image} alt={group.title} width="160" height="120" loading="lazy"/>
                            <h2>{group.title}</h2>
                            <p>{group.description}</p>
                            <ul>
                                {group.items.map((item) => <li key={item}>{item}</li>)}
                            </ul>
                        </article>
                        );
                    })}
                </div>
            </section>

            <section className={styles.section}>
                <SectionHeading eyebrow="Направления" title="Другие позиции"/>
                <div className={styles.products}>
                    {FEATURED_PRODUCTS.map((item) => {
                        const isAvailable = posts.isCategoryAvailable(item.exampleCategory);
                        return (
                        <article
                            key={item.name}
                            role={isAvailable ? 'button' : undefined}
                            tabIndex={isAvailable ? 0 : undefined}
                            className={isAvailable ? styles.clickable : ''}
                            onClick={isAvailable ? () => openCategory(item.exampleCategory) : undefined}
                            onKeyDown={isAvailable ? (event) => openCategoryFromKeyboard(event, item.exampleCategory) : undefined}
                        >
                            <img src={item.image} alt={item.name} width="140" height="110" loading="lazy"/>
                            <div>
                                <h2>{item.name}</h2>
                                <p>{item.category}</p>
                            </div>
                        </article>
                        );
                    })}
                </div>
            </section>
        </Container>
        <ExamplesByCategoryModal
            category={selectedCategory}
            show={Boolean(selectedCategory)}
            onHide={() => setSelectedCategory('')}
        />
        </>
    );
};

export default CalculatorsList;
